import React, { useState } from 'react';
function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [query, setQuery] = useState('');
  const [searchStatus, setSearchStatus] = useState('');
  const handleSearch = event => {
    event.preventDefault();
    const term = query.trim().toLocaleLowerCase();
    if (!term) return;
    const root = document.querySelector('.bluevale-home');
    const match = [...root.querySelectorAll('h1,h2,h3,h4,p,.label')].find(item => item.textContent.toLocaleLowerCase().includes(term));
    if (!match) { setSearchStatus('No matching content found.'); return; }
    setSearchStatus('Showing a matching section.');
    match.scrollIntoView({ behavior: 'smooth', block: 'center' });
    match.classList.add('search-result-highlight');
    window.setTimeout(() => match.classList.remove('search-result-highlight'), 1800);
    setMenuOpen(false);
  };
  return (
    <>
      <div className="topbar">
        <div className="wrap">
          <div className="announce">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M3 11l18-7-7 18-2-8-9-3z"></path>
            </svg>
            <span>{'Admissions Open 2026–27'}</span>
          </div>
          <div className="right">
            <a href="https://apps.pakcampus.com/">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                <circle cx="12" cy="7" r="4"></circle>
              </svg>
              {'Portal Login'}
            </a>

            {/* <button type="button" className="search-toggle" aria-label="Search" aria-expanded={searchOpen} onClick={() => setSearchOpen(!searchOpen)}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="11" cy="11" r="7"></circle>
              <path d="m21 21-4.3-4.3"></path>
            </svg>
          </button> */}
          </div>
        </div>
      </div>
      <header>
        <nav>
          <a href="#top" className="brand">
            <img className="brand-logo" src="/image/logo.png" alt="Comprehensive High School" />
            <span className="word">
              {'Comprehensive'}
              <span>{'High School'}</span>
            </span>
          </a>
          <ul className={`nav-links${menuOpen ? ' open' : ''}`}>
            <li>
              <a
                href="#top"
                className="active"
                onClick={() => setMenuOpen(false)}
              >
                {'Home'}
              </a>
            </li>
            <li>
              <a href="#about" onClick={() => setMenuOpen(false)}>
                {'About Us'}
              </a>
            </li>
            <li>
              <a href="#academics" onClick={() => setMenuOpen(false)}>
                {'Academics'}
              </a>
            </li>
            <li>
              <a href="#admissions" onClick={() => setMenuOpen(false)}>
                {'Admissions'}
              </a>
            </li>
            <li>
              <a href="#campus" onClick={() => setMenuOpen(false)}>
                {'Campus Life'}
              </a>
            </li>
            <li>
              <a href="#contact" onClick={() => setMenuOpen(false)}>
                {'Contact Us'}
              </a>
            </li>
          </ul>
        
       
        </nav>
        {searchOpen && (
          <form className="site-search" role="search" onSubmit={handleSearch}>
            <input
              type="search"
              placeholder="Search this page"
              aria-label="Search this page"
              value={query}
              onChange={(event) => setQuery(event.target.value)}
              onKeyDown={(event) =>
                event.key === 'Escape' && setSearchOpen(false)
              }
              autoFocus
            />
            <button type="submit">Search</button>
            <span className="search-status" aria-live="polite">
              {searchStatus}
            </span>
          </form>
        )}
      </header>
    </>
  );
}

export default SiteHeader;
